import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard, AuthSecureGuard } from "./auth.guard";

const routes: Routes = [
  /* {
    path: "",
    redirectTo: "profile",
    pathMatch: "full"
  },*/
  {
    path: "profile",
    loadChildren: () =>
      import("./profile/profile.module").then((m) => m.ProfilePageModule),
  },
  {
    path: "fight-sliders",
    loadChildren: () =>
      import("./newUi/pages/fight-slider/fight-slider.module").then(
        (m) => m.FightSliderPageModule
      ),
  },
  {
    path: "fight-slider",
    loadChildren: () =>
      import("./fight-slider/fight-slider.module").then(
        (m) => m.FightSliderPageModule
      ),
  },
  {
    path: "demographic",
    loadChildren: () =>
      import("./demographic/demographic.module").then(
        (m) => m.DemographicPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "lifestyle",
    loadChildren: () =>
      import("./lifestyle/lifestyle.module").then((m) => m.LifestylePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "diet",
    loadChildren: () =>
      import("./diet/diet.module").then((m) => m.DietPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "your-plan",
    loadChildren: () =>
      import("./your-plan/your-plan.module").then((m) => m.YourPlanPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "diet-pref",
    loadChildren: () =>
      import("./diet-pref/diet-pref.module").then((m) => m.DietPrefPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "lifestyle-pref",
    loadChildren: () =>
      import("./lifestyle-pref/lifestyle-pref.module").then(
        (m) => m.LifestylePrefPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "demographic-pref",
    loadChildren: () =>
      import("./demographic-pref/demographic-pref.module").then(
        (m) => m.DemographicPrefPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "health",
    loadChildren: () =>
      import("./health/health.module").then((m) => m.HealthPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "food",
    loadChildren: () =>
      import("./food/food.module").then((m) => m.FoodPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "height",
    loadChildren: () =>
      import("./height/height.module").then((m) => m.HeightPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "consume",
    loadChildren: () =>
      import("./consume/consume.module").then((m) => m.ConsumePageModule),
    canActivate: [AuthGuard, AuthSecureGuard],
  },
  {
    path: "profile",
    loadChildren: () =>
      import("./profile/profile.module").then((m) => m.ProfilePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "weight",
    loadChildren: () =>
      import("./weight/weight.module").then((m) => m.WeightPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "bmi",
    loadChildren: () => import("./bmi/bmi.module").then((m) => m.BmiPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "age",
    loadChildren: () => import("./age/age.module").then((m) => m.AgePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "wakeup",
    loadChildren: () =>
      import("./wakeup/wakeup.module").then((m) => m.WakeupPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "sleep",
    loadChildren: () =>
      import("./sleep/sleep.module").then((m) => m.SleepPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "sleep-type",
    loadChildren: () =>
      import("./sleep-type/sleep-type.module").then(
        (m) => m.SleepTypePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "leave-office",
    loadChildren: () =>
      import("./leave-office/leave-office.module").then(
        (m) => m.LeaveOfficePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "come-back",
    loadChildren: () =>
      import("./come-back/come-back.module").then((m) => m.ComeBackPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "country",
    loadChildren: () =>
      import("./country/country.module").then((m) => m.CountryPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "community",
    loadChildren: () =>
      import("./community/community.module").then((m) => m.CommunityPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "food-pref",
    loadChildren: () =>
      import("./food-pref/food-pref.module").then((m) => m.FoodPrefPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "alchohal",
    loadChildren: () =>
      import("./alchohal/alchohal.module").then((m) => m.AlchohalPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "water-drink",
    loadChildren: () =>
      import("./water-drink/water-drink.module").then(
        (m) => m.WaterDrinkPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "single",
    loadChildren: () =>
      import("./single/single.module").then((m) => m.SinglePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "marital",
    loadChildren: () =>
      import("./marital/marital.module").then((m) => m.MaritalPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "stress",
    loadChildren: () =>
      import("./stress/stress.module").then((m) => m.StressPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "activity",
    loadChildren: () =>
      import("./activity/activity.module").then((m) => m.ActivityPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "diet-prog",
    loadChildren: () =>
      import("./diet-prog/diet-prog.module").then((m) => m.DietProgPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "drinks",
    loadChildren: () =>
      import("./drinks/drinks.module").then((m) => m.DrinksPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "snacks",
    loadChildren: () =>
      import("./snacks/snacks.module").then((m) => m.SnacksPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "fruits",
    loadChildren: () =>
      import("./fruits/fruits.module").then((m) => m.FruitsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "dishes",
    loadChildren: () =>
      import("./dishes/dishes.module").then((m) => m.DishesPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "pules-curries",
    loadChildren: () =>
      import("./pules-curries/pules-curries.module").then(
        (m) => m.PulesCurriesPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "milk-product",
    loadChildren: () =>
      import("./milk-product/milk-product.module").then(
        (m) => m.MilkProductPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "rice-pref",
    loadChildren: () =>
      import("./rice-pref/rice-pref.module").then((m) => m.RicePrefPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "roti-pref",
    loadChildren: () =>
      import("./roti-pref/roti-pref.module").then((m) => m.RotiPrefPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "dinner",
    loadChildren: () =>
      import("./dinner/dinner.module").then((m) => m.DinnerPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "calories",
    loadChildren: () =>
      import("./calories/calories.module").then((m) => m.CaloriesPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "gender",
    loadChildren: () =>
      import("./gender/gender.module").then((m) => m.GenderPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "options",
    loadChildren: () =>
      import("./options/options.module").then((m) => m.OptionsPageModule),
    canActivate: [AuthGuard],
  },

  {
    path: "yesterday-plan",
    loadChildren: () =>
      import("./yesterday-plan/yesterday-plan.module").then(
        (m) => m.YesterdayPlanPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "your-tips",
    loadChildren: () =>
      import("./your-tips/your-tips.module").then((m) => m.YourTipsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "afterdiet",
    loadChildren: () =>
      import("./afterdiet/afterdiet.module").then((m) => m.AfterdietPageModule),
  },
  {
    path: "unlock-plan",
    loadChildren: () =>
      import("./unlock-plan/unlock-plan.module").then(
        (m) => m.UnlockPlanPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "weight-graph",
    loadChildren: () =>
      import("./weight-graph/weight-graph.module").then(
        (m) => m.WeightGraphPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "edit-profile",
    loadChildren: () =>
      import("./edit-profile/edit-profile.module").then(
        (m) => m.EditProfilePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "notification",
    loadChildren: () =>
      import("./notification/notification.module").then(
        (m) => m.NotificationPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "unsubscribe",
    loadChildren: () =>
      import("./unsubscribe/unsubscribe.module").then(
        (m) => m.UnsubscribePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "faq",
    loadChildren: () => import("./faq/faq.module").then((m) => m.FaqPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "faq-qa",
    loadChildren: () =>
      import("./faq-qa/faq-qa.module").then((m) => m.FaqQaPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "upgrade-plan",
    loadChildren: () =>
      import("./upgrade-plan/upgrade-plan.module").then(
        (m) => m.UpgradePlanPageModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: "faq-other",
    loadChildren: () =>
      import("./faq-other/faq-other.module").then((m) => m.FaqOtherPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "cancel-start",
    loadChildren: () =>
      import("./cancel-start/cancel-start.module").then(
        (m) => m.CancelStartPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "cancel-two",
    loadChildren: () =>
      import("./cancel-two/cancel-two.module").then(
        (m) => m.CancelTwoPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "cancel-three",
    loadChildren: () =>
      import("./cancel-three/cancel-three.module").then(
        (m) => m.CancelThreePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "cancel-four",
    loadChildren: () =>
      import("./cancel-four/cancel-four.module").then(
        (m) => m.CancelFourPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "faq-thanks",
    loadChildren: () =>
      import("./faq-thanks/faq-thanks.module").then(
        (m) => m.FaqThanksPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "terms",
    loadChildren: () =>
      import("./terms/terms.module").then((m) => m.TermsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "suggestion",
    loadChildren: () =>
      import("./suggestion/suggestion.module").then(
        (m) => m.SuggestionPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "jurney",
    loadChildren: () =>
      import("./jurney/jurney.module").then((m) => m.JurneyPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "initial-slider",
    loadChildren: () =>
      import("./initial-slider/initial-slider.module").then(
        (m) => m.InitialSliderPageModule
      ),
  },
  {
    path: "payment-container",
    loadChildren: () =>
      import("./payment-container/payment-container.module").then(
        (m) => m.PaymentContainerPageModule
      ),
  },
  {
    path: "food-detail",
    loadChildren: () =>
      import("./food-detail/food-detail.module").then(
        (m) => m.FoodDetailPageModule
      ),
  },
  {
    path: "subscription",
    loadChildren: () =>
      import("./subscription/subscription.module").then(
        (m) => m.SubscriptionPageModule
      ),
  },
  {
    path: "option-upgrade",
    loadChildren: () =>
      import("./option-upgrade/option-upgrade.module").then(
        (m) => m.OptionUpgradePageModule
      ),
  },
  {
    path: "slot-dinner-time",
    loadChildren: () =>
      import("./slot-dinner-time/slot-dinner-time.module").then(
        (m) => m.SlotDinnerTimePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "slot-post-dinner-time",
    loadChildren: () =>
      import("./slot-post-dinner-time/slot-post-dinner-time.module").then(
        (m) => m.SlotPostDinnerTimePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "slot-bf-time",
    loadChildren: () =>
      import("./slot-bf-time/slot-bf-time.module").then(
        (m) => m.SlotBfTimePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "slot-lunch-time",
    loadChildren: () =>
      import("./slot-lunch-time/slot-lunch-time.module").then(
        (m) => m.SlotLunchTimePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "blog",
    loadChildren: () =>
      import("./blog/blog.module").then((m) => m.BlogPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "news",
    loadChildren: () =>
      import("./news/news.module").then((m) => m.NewsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "detox-warning",
    loadChildren: () =>
      import("./detox-warning/detox-warning.module").then(
        (m) => m.DetoxWarningPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "activity-tracker",
    loadChildren: () =>
      import("./activity-tracker/activity-tracker.module").then(
        (m) => m.ActivityTrackerPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "calories-deficit",
    loadChildren: () =>
      import("./calories-deficit/calories-deficit.module").then(
        (m) => m.CaloriesDeficitPageModule
      ),
  },
  {
    path: "plan-type",
    loadChildren: () =>
      import("./plan-type/plan-type.module").then((m) => m.PlanTypePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "key-mantras",
    loadChildren: () =>
      import("./key-mantras/key-mantras.module").then(
        (m) => m.KeyMantrasPageModule
      ),
  },
  {
    path: "water-guage",
    loadChildren: () =>
      import("./water-guage/water-guage.module").then(
        (m) => m.WaterGuagePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "meal-guage",
    loadChildren: () =>
      import("./meal-guage/meal-guage.module").then(
        (m) => m.MealGuagePageModule
      ),
  },
  {
    path: "weight-guage",
    loadChildren: () =>
      import("./weight-guage/weight-guage.module").then(
        (m) => m.WeightGuagePageModule
      ),
  },
  {
    path: "analysis",
    loadChildren: () =>
      import("./analysis/analysis.module").then((m) => m.AnalysisPageModule),
  },
  {
    path: "about-us",
    loadChildren: () =>
      import("./about-us/about-us.module").then((m) => m.AboutUsPageModule),
  },
  {
    path: "other-foods-selection",
    loadChildren: () =>
      import("./other-foods-selection/other-foods-selection.module").then(
        (m) => m.OtherFoodsSelectionPageModule
      ),
  },
  {
    path: "select-plan-types",
    loadChildren: () =>
      import("./select-plan-types/select-plan-types.module").then(
        (m) => m.SelectPlanTypesPageModule
      ),
  },
  {
    path: "story-board",
    loadChildren: () =>
      import("./story-board/story-board.module").then(
        (m) => m.StoryBoardPageModule
      ),
  },
  {
    path: "referral-transactions",
    loadChildren: () =>
      import("./referral-transactions/referral-transactions.module").then(
        (m) => m.ReferralTransactionsPageModule
      ),
  },
  {
    path: "personalise",
    loadChildren: () =>
      import("./personalise/personalise.module").then(
        (m) => m.PersonalisePageModule
      ),
  },
  {
    path: "user-name",
    loadChildren: () =>
      import("./user-name/user-name.module").then((m) => m.UserNamePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "todays-calorie-count",
    loadChildren: () =>
      import("./todays-calorie-count/todays-calorie-count.module").then(
        (m) => m.TodaysCalorieCountPageModule
      ),
  },
  {
    path: "add-edit-todays-calorie-count",
    loadChildren: () =>
      import(
        "./add-edit-todays-calorie-count/add-edit-todays-calorie-count.module"
      ).then((m) => m.AddEditTodaysCalorieCountPageModule),
  },
  {
    path: "user-profile",
    loadChildren: () =>
      import("./user-profile/user-profile.module").then(
        (m) => m.UserProfilePageModule
      ),
  },
  {
    path: "list-todays-calorie-count",
    loadChildren: () =>
      import(
        "./list-todays-calorie-count/list-todays-calorie-count.module"
      ).then((m) => m.ListTodaysCalorieCountPageModule),
  },
  {
    path: "water-notification-settings",
    loadChildren: () =>
      import(
        "./water-notification-settings/water-notification-settings.module"
      ).then((m) => m.WaterNotificationSettingsPageModule),
  },
  {
    path: "nutri-score",
    loadChildren: () =>
      import("./nutri-score/nutri-score.module").then(
        (m) => m.NutriScorePageModule
      ),
  },
  {
    path: "fasting-notification-settings",
    loadChildren: () =>
      import(
        "./fasting-notification-settings/fasting-notification-settings.module"
      ).then((m) => m.FastingNotificationSettingsPageModule),
  },
  {
    path: "facts",
    loadChildren: () =>
      import("./facts/facts.module").then((m) => m.FactsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "profile-menu",
    loadChildren: () =>
      import("./profile-menu/profile-menu.module").then(
        (m) => m.ProfileMenuPageModule
      ),
  },
  {
    path: "exercises",
    loadChildren: () =>
      import("./exercises/exercises.module").then((m) => m.ExercisesPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "recipe-new",
    loadChildren: () =>
      import("./recipe-new/recipe-new.module").then(
        (m) => m.RecipeNewPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "recipe-detail",
    loadChildren: () =>
      import("./recipe-detail/recipe-detail.module").then(
        (m) => m.RecipeDetailPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "ecommerce",
    loadChildren: () =>
      import("./ecommerce/ecommerce.module").then((m) => m.EcommercePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "corporate-login",
    loadChildren: () =>
      import("./corporate-login/corporate-login.module").then(
        (m) => m.CorporateLoginPageModule
      ),
  },
  {
    path: "address",
    loadChildren: () =>
      import("./address/address.module").then((m) => m.AddressPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "view-order",
    loadChildren: () =>
      import("./view-order/view-order.module").then(
        (m) => m.ViewOrderPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "corporate-otp",
    loadChildren: () =>
      import("./corporate-otp/corporate-otp.module").then(
        (m) => m.CorporateOtpPageModule
      ),
  },
  {
    path: "survey",
    loadChildren: () =>
      import("./survey/survey.module").then((m) => m.SurveyPageModule),
    //  canActivate: [AuthGuard]
  },
  {
    path: "wellnessbox-order-confirmation",
    loadChildren: () =>
      import(
        "./wellnessbox-order-confirmation/wellnessbox-order-confirmation.module"
      ).then((m) => m.WellnessboxOrderConfirmationPageModule),
  },
  {
    path: "type-slider",
    loadChildren: () =>
      import("./type-slider/type-slider.module").then(
        (m) => m.TypeSliderPageModule
      ),
  },
  {
    path: "workout-timing-select",
    loadChildren: () =>
      import("./workout-timing-select/workout-timing-select.module").then(
        (m) => m.WorkoutTimingSelectPageModule
      ),
  },
  {
    path: "protien-tracker",
    loadChildren: () =>
      import("./protien-tracker/protien-tracker.module").then(
        (m) => m.ProtienTrackerPageModule
      ),
  },
  {
    path: "protien-story-board",
    loadChildren: () =>
      import("./protien-story-board/protien-story-board.module").then(
        (m) => m.ProtienStoryBoardPageModule
      ),
  },
  {
    path: "breathe-type",
    loadChildren: () =>
      import("./breathe-type/breathe-type.module").then(
        (m) => m.BreatheTypePageModule
      ),
  },
  {
    path: "vitals",
    loadChildren: () =>
      import("./vitals/vitals.module").then((m) => m.VitalsPageModule),
  },
  {
    path: "vitals-blood-pressure",
    loadChildren: () =>
      import("./vitals-blood-pressure/vitals-blood-pressure.module").then(
        (m) => m.VitalsBloodPressurePageModule
      ),
  },
  {
    path: "vitals-fasting",
    loadChildren: () =>
      import("./vitals-fasting/vitals-fasting.module").then(
        (m) => m.VitalsFastingPageModule
      ),
  },
  {
    path: "vitals-after-fasting",
    loadChildren: () =>
      import("./vitals-after-fasting/vitals-after-fasting.module").then(
        (m) => m.VitalsAfterFastingPageModule
      ),
  },
  {
    path: "consume-v",
    loadChildren: () =>
      import("./consume-v/consume-v.module").then((m) => m.ConsumeVPageModule),
  },
  {
    path: "boarding",
    loadChildren: () =>
      import("./newUi/onboarding-screen/boarding/boarding.module").then(
        (m) => m.BoardingPageModule
      ),
  },
  {
    path: "boarding2",
    loadChildren: () =>
      import("./newUi/onboarding-screen/boarding2/boarding2.module").then(
        (m) => m.Boarding2PageModule
      ),
  },
  {
    path: "boarding3",
    loadChildren: () =>
      import("./newUi/onboarding-screen/boarding3/boarding3.module").then(
        (m) => m.Boarding3PageModule
      ),
  },
  {
    path: "boarding4",
    loadChildren: () =>
      import("./newUi/onboarding-screen/boarding4/boarding4.module").then(
        (m) => m.Boarding4PageModule
      ),
  },
  {
    path: "boarding5",
    loadChildren: () =>
      import("./newUi/onboarding-screen/boarding5/boarding5.module").then(
        (m) => m.Boarding5PageModule
      ),
  },
  {
    path: "final-boarding",
    loadChildren: () =>
      import(
        "./newUi/onboarding-screen/final-boarding/final-boarding.module"
      ).then((m) => m.FinalBoardingPageModule),
  },
  {
    path: "boarding1",
    loadChildren: () =>
      import("./newUi/onboarding-screen/boarding1/boarding1.module").then(
        (m) => m.Boarding1PageModule
      ),
  },
  {
    path: "water-intake",
    loadChildren: () =>
      import("./newUi/Components/water-intake/water-intake.module").then(
        (m) => m.WaterIntakePageModule
      ),
  },
  {
    path: "new-calories",
    loadChildren: () =>
      import("./newUi/Components/calories/calories.module").then(
        (m) => m.CaloriesPageModule
      ),
  },
  {
    path: "remaining-calories",
    loadChildren: () =>
      import("./newUi/Components/remaining-calories/remainingcalories.module").then((m) => m.RemainingCaloriesPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "calories-burned",
    loadChildren: () =>
      import("./newUi/Components/calories-burned/calories-burned.module").then(
        (m) => m.CaloriesBurnedPageModule
      ),
  },
  {
    path: "meal-workout",
    loadChildren: () =>
      import("./newUi/Components/meal-workout/meal-workout.module").then(
        (m) => m.MealWorkoutPageModule
      ),
  },
  {
    path: "new-home",
    loadChildren: () =>
      import("./newUi/pages/new-home/new-home.module").then(
        (m) => m.NewHomePageModule
      ),
  },
  {
    path: "tabs",
    loadChildren: () =>
      import("./newUi/tabs/tabs.module").then((m) => m.TabsPageModule),
  },
  {
    path: "new-diet",
    loadChildren: () =>
      import("./newUi/pages/new-diet/new-diet.module").then(
        (m) => m.NewDietPageModule
      ),
  },
  {
    path: "new-profile",
    loadChildren: () =>
      import("./newUi/pages/new-profile/new-profile.module").then(
        (m) => m.NewProfilePageModule
      ),
  },
  {
    path: "appointent",
    loadChildren: () =>
      import("./newUi/Components/appointent/appointent.module").then(
        (m) => m.AppointentPageModule
      ),
  },
  {
    path: "premium-member",
    loadChildren: () =>
      import("./newUi/pages/premium-member/premium-member.module").then(
        (m) => m.PremiumMemberPageModule
      ),
  },
  {
    path: "premium-popup",
    loadChildren: () =>
      import(
        "./newUi/pages/premium-member/premium-popup/premium-popup.module"
      ).then((m) => m.PremiumPopupPageModule),
  },
  {
    path: "premium-member-access",
    loadChildren: () =>
      import(
        "./newUi/pages/premium-member/premium-member-access/premium-member-access.module"
      ).then((m) => m.PremiumMemberAccessPageModule),
  },
  {
    path: "recipe",
    loadChildren: () =>
      import("./newUi/components/recipe/recipe.module").then(
        (m) => m.RecipePageModule
      ),
  },
  {
    path: "alternate-diet",
    loadChildren: () =>
      import("./newUi/pages/alternate-diet/alternate-diet.module").then(
        (m) => m.AlternateDietPageModule
      ),
  },
  {
    path: "portion-count",
    loadChildren: () =>
      import(
        "./newUi/pages/alternate-diet/portion-count/portion-count.module"
      ).then((m) => m.PortionCountPageModule),
  },
  {
    path: "alternate-search",
    loadChildren: () =>
      import("./newUi/pages/alternate-search/alternate-search.module").then(
        (m) => m.AlternateSearchPageModule
      ),
  },
  {
    path: "search",
    loadChildren: () =>
      import("./newUi/pages/search/search.module").then(
        (m) => m.SearchPageModule
      ),
  },
  {
    path: "selectslot-popup",
    loadChildren: () =>
      import("./newUi/pages/selectslot-popup/selectslot-popup.module").then(
        (m) => m.SelectslotPopupPageModule
      ),
  },
  {
    path: "small-meal-card",
    loadChildren: () =>
      import("./newUi/Components/small-meal-card/small-meal-card.module").then(
        (m) => m.SmallMealCardPageModule
      ),
  },
  {
    path: "view-product",
    loadChildren: () =>
      import("./newUi/pages/view-product/view-product.module").then(
        (m) => m.ViewProductPageModule
      ),
  },
  {
    path: "new-menu",
    loadChildren: () =>
      import("./newUi/pages/new-menu/new-menu.module").then(
        (m) => m.NewMenuPageModule
      ),
  },
  {
    path: "landing-slider",
    loadChildren: () =>
      import("./newUi/pages/landing-slider/landing-slider.module").then(
        (m) => m.LandingSliderPageModule
      ),
  },
  {
    path: "new-activity",
    loadChildren: () =>
      import("./newUi/pages/new-activity/new-activity.module").then(
        (m) => m.NewActivityPageModule
      ),
  },
  {
    path: "activity-plan-card",
    loadChildren: () =>
      import(
        "./newUi/Components/activity-plan-card/activity-plan-card.module"
      ).then((m) => m.ActivityPlanCardPageModule),
  },
  {
    path: "activity-info",
    loadChildren: () =>
      import(
        "./newUi/pages/new-activity/activity-info/activity-info.module"
      ).then((m) => m.ActivityInfoPageModule),
  },
  {
    path: "smart-gummies",
    loadChildren: () =>
      import("./newUi/pages/smart-gummies/smart-gummies.module").then(
        (m) => m.SmartGummiesPageModule
      ),
  },
  {
    path: "smart-gummie-address",
    loadChildren: () =>
      import(
        "./newUi/pages/smart-gummie-address/smart-gummie-address.module"
      ).then((m) => m.SmartGummieAddressPageModule),
  },
  {
    path: "smart-gummie-order",
    loadChildren: () =>
      import("./newUi/pages/smart-gummie-order/smart-gummie-order.module").then(
        (m) => m.SmartGummieOrderPageModule
      ),
  },
  {
    path: "restaurant-card",
    loadChildren: () =>
      import("./newUi/Components/restaurant-card/restaurant-card.module").then(
        (m) => m.RestaurantCardPageModule
      ),
  },
  {
    path: "notifications",
    loadChildren: () =>
      import("./newUi/pages/notification/notification.module").then(
        (m) => m.NotificationPageModule
      ),
  },
  {
    path: 'location-drop',
    loadChildren: () => import('./newUi/Components/location-drop/location-drop.module').then( m => m.LocationDropPageModule)
  },
  {
    path: 'view-suggestions',
    loadChildren: () => import('./newUi/pages/view-suggestions/view-suggestions.module').then( m => m.ViewSuggestionsPageModule)
  },
  {
    path: 'filter-card',
    loadChildren: () => import('./newUi/Components/filter-card/filter-card.module').then( m => m.FilterCardPageModule)
  },
  {
    path: 'view-restaurant',
    loadChildren: () => import('./newUi/pages/view-restaurant/view-restaurant.module').then( m => m.ViewRestaurantPageModule)
  },
  {
    path: 'filter-sort',
    loadChildren: () => import('./newUi/Components/filter-sort/filter-sort.module').then( m => m.FilterSortPageModule)
  },
  {
    path: 'add-foods',
    loadChildren: () => import('./newUi/Components/add-foods/add-foods.module').then( m => m.AddFoodsPageModule)
  },
  {
    path: 'trial-card',
    loadChildren: () => import('./newUi/Components/trial-card/trial-card.module').then( m => m.TrialCardPageModule)
  },
  {
    path: 'works-guide',
    loadChildren: () => import('./newUi/Components/howprogramworksguide/howprogramworksguide.module').then( m => m.HowprogramworksguidePageModule)
  },
  {
    path: 'offer',
    loadChildren: () => import('./newUi/pages/offers/offers.module').then( m => m.OffersPageModule)
  },
  {
    path: 'all-calory-chart',
    loadChildren: () => import('./newUi/pages/all-calory-chart/all-calory-chart.module').then( m => m.AllCaloryChartPageModule)
  },
  {
    path: "weight-log",
    loadChildren: () =>
      import("src/app/components/weight-log/weight-log.module").then(
        (m) => m.WeightLogPageModule
      ),
  },
  {
    path: 'no-active-plan',
    loadChildren: () => import('./newUi/Components/no-active-plan/no-active-plan.module').then( m => m.NoActivePlanPageModule)
  },

  // {
  //   path: 'chat',
  //   loadChildren: () => import('./chat/chat.module').then( m => m.ChatPageModule)
  // },
  // {
  //   path: 'diet-analysis',
  //   loadChildren: () => import('./diet-analysis/diet-analysis.module').then( m => m.DietAnalysisPageModule)
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules,
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
